export default __webpack_public_path__ + "fonts/WaterletHandOutline-Bold.eot";